import ReportsAdapter from './base';

export default class ReportTemplate extends ReportsAdapter {
  modelNamePlural = 'report-templates';

  buildQuery(snapshot) {
    let query = super.buildQuery(...arguments);
    if (snapshot.adapterOptions && snapshot.adapterOptions.includeSections) {
      query.includeSections = true;
    }
    return query;
  }
}
